import { useMemo } from 'react';
import { PostModel } from '../../../../data-layer/posts/types';

interface UseItemsWithAdParams {
    items: PostModel[];
    adInterval: number;
    adTopFeedOffset: number;
}

const AD_CARD = 'ad_card';

interface AdCard {
    isAd: true;
    id: string;
}

export type PostModelWithAd = (PostModel & { isAd: false }) | AdCard;

export const useItemsWithAd = ({ items, adInterval, adTopFeedOffset }: UseItemsWithAdParams) =>
    useMemo(() => {
        let adCardCount = 0;

        return items.reduce<Array<(PostModel & { isAd: false }) | AdCard>>((acc, item, index) => {
            if ((index + adCardCount - adTopFeedOffset) % adInterval === 0) {
                acc.push({ isAd: true, id: AD_CARD + '_' + adCardCount });
                adCardCount++;
            }

            acc.push({ ...item, isAd: false });

            return acc;
        }, []);
    }, [items]);
